// Wires the buybox's plan rows to the hidden inputs its cart form posts,
// toggles the nutrition panel, slides the extras panel between the daily plan
// cards, and drives the sticky buy bar. Money is never computed here: every
// radio carries the price, slash and CTA copy that
// snippets/lp-offer-price.liquid stamped on it. The gift panel, the split
// button, the CTA head/sub and the ticks exist only on pages that opt in;
// each is filled only when its element is present.
(function () {
  // iOS Safari applies :active, and so every LP press state, only where a touchstart listener exists.
  document.addEventListener('touchstart', function () {}, { passive: true });
  var LIVE_GIFT_PANEL = '.lp-giftpanel:not([data-lp-ghost])';
  function setText(root, selector, text) {
    var element = root.querySelector(selector);
    if (element) element.textContent = text;
  }
  function token(el, name) {
    return getComputedStyle(el).getPropertyValue(name).trim();
  }
  // The store's CDN minifies lp-sleep.css, so a timing token written 300ms is
  // served as .3s. Reads a CSS <time> in milliseconds; anything else is NaN.
  function ms(time) {
    var m = /^\s*([+-]?(?:\d*\.)?\d+(?:e[+-]?\d+)?)(m?s)\s*$/i.exec(time);
    return m ? m[1] * (m[2].toLowerCase() === 's' ? 1000 : 1) : NaN;
  }
  function reducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }
  // Moves the panel to the chosen card's slot. The card it leaves keeps a
  // copy while its slot closes (CSS, on the morph tokens), so the panel reads
  // as handed from one card to the other; a copy still closing in the target
  // slot goes first, so a tap mid-switch retargets the slide instead of
  // stacking the copy under the panel. Scroll anchoring is off for the length
  // of the switch: with the leaving card above the viewport, anchoring would
  // step the page by the slot's height to hold the tapped card still.
  var lastSwitch = null;
  function switchSlot(panel, slot) {
    var from = panel.parentNode;
    var animated = !reducedMotion() && from && from.hasAttribute('data-lp-gifts-slot');
    Array.prototype.forEach.call(slot.querySelectorAll('[data-lp-ghost]'), function (g) { g.remove(); });
    if (animated) {
      var ghost = panel.cloneNode(true);
      ghost.setAttribute('data-lp-ghost', '');
      ghost.setAttribute('aria-hidden', 'true');
      ghost.inert = true;
      from.appendChild(ghost);
      var life = (ms(token(panel, '--lp-dur-morph')) || 300) + 60;
      setTimeout(function () { ghost.remove(); }, life);
      var root = document.documentElement;
      var current = lastSwitch = {};
      root.style.overflowAnchor = 'none';
      setTimeout(function () {
        // Two frames after the last step has laid out without anchoring.
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            if (lastSwitch === current) root.style.overflowAnchor = '';
          });
        });
      }, life);
    }
    slot.appendChild(panel);
  }
  // Locks each panel gift whose unlock quantity the row does not reach, puts
  // the row's coupon on the coupon gift card, and returns "unlocked/total"
  // for the count line and the CTA sub.
  function applyGiftPanel(form, radio, level) {
    var panel = form.querySelector(LIVE_GIFT_PANEL);
    if (!panel) return '';
    if (panel.classList.contains('lp-giftpanel--selection')) {
      var row = radio.closest('.lp-plan');
      var slot = row && row.querySelector('[data-lp-gifts-slot]');
      if (slot && panel.parentNode !== slot) switchSlot(panel, slot);
    }
    var coupon = panel.querySelector('[data-lp-coupon-gift]');
    if (coupon) {
      setText(coupon, '.lp-gcard__title', radio.getAttribute('data-coupon-gift-title') || '');
      setText(coupon, '.lp-gift__media--coupon', radio.getAttribute('data-coupon-gift-text') || '');
    }
    var daily = !!form.closest('.lp-shop--daily');
    if (daily) panel.hidden = !level;
    var cards = panel.querySelectorAll('.lp-gcard');
    var unlocked = 0;
    for (var i = 0; i < cards.length; i++) {
      var locked = Number(cards[i].getAttribute('data-min-quantity')) > level;
      cards[i].classList.toggle('lp-gcard--off', locked);
      if (daily) cards[i].hidden = locked;
      if (!locked) unlocked++;
    }
    var count = unlocked + '/' + cards.length;
    var line = panel.querySelector('.lp-giftpanel__count');
    if (line) {
      line.textContent = line.getAttribute('data-lp-unlocked-line').replace('{n}', unlocked).replace('{total}', cards.length);
    }
    return count;
  }
  function applyCheckedRow(form) {
    var radio = form.querySelector('.lp-offer__input:checked');
    if (!radio) return;
    form.querySelector('[data-lp-variant]').value = radio.getAttribute('data-variant-id');
    form.querySelector('[data-lp-quantity]').value = radio.getAttribute('data-quantity');
    var plan = form.querySelector('[data-lp-selling-plan]');
    var planId = radio.getAttribute('data-selling-plan');
    plan.value = planId;
    plan.disabled = !planId; // a disabled input is left out of the POST
    form.querySelector('[data-lp-return-to]').value = radio.getAttribute('data-return-to');
    var cards = form.querySelectorAll('.lp-plan');
    for (var i = 0; i < cards.length; i++) {
      cards[i].classList.toggle('lp-plan--selected', cards[i].contains(radio));
    }
    var submit = form.querySelector('[data-lp-submit]');
    var splitText = form.querySelector('.lp-bigcta__text');
    if (splitText) {
      splitText.textContent = radio.getAttribute('data-cta');
      var was = form.querySelector('.lp-bigcta__was');
      if (was) {
        was.textContent = radio.getAttribute('data-slash') || '';
        was.hidden = !was.textContent;
      }
      setText(form, '.lp-bigcta__price', radio.getAttribute('data-price') + (radio.getAttribute('data-price-suffix') || ''));
    } else if (submit) {
      submit.textContent = radio.getAttribute('data-cta');
    }
    var gifts = applyGiftPanel(form, radio, (planId || radio.getAttribute('data-gifts-eligible') === 'true') ? Number(radio.getAttribute('data-supply-quantity')) : 0);
    setText(form, '.lp-ctahead', radio.getAttribute('data-cta-head') || '');
    setText(form, '.lp-ctasub', (radio.getAttribute('data-cta-sub') || '').replace('{gifts}', gifts));
    var ticks = form.querySelector('.lp-ctaticks');
    if (ticks) {
      ticks.hidden = !planId;
      var line = ticks.querySelector('[data-lp-cta-line]');
      if (line) {
        var text = radio.getAttribute('data-cta-line') || '';
        line.hidden = !text;
        setText(line, 'span:last-child', text);
      }
    }
  }
  // The one-time text button submits immediately with no subscription or
  // subscription coupon. Reapply the chosen plan for a later main-CTA submit.
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches('[data-lp-buybox]')) return;
    var once = event.submitter && event.submitter.matches('[data-lp-buy-once]');
    if (!once) { applyCheckedRow(form); return; }
    form.querySelector('[data-lp-variant]').value = event.submitter.getAttribute('data-variant-id');
    form.querySelector('[data-lp-quantity]').value = event.submitter.getAttribute('data-quantity');
    var plan = form.querySelector('[data-lp-selling-plan]');
    plan.value = '';
    plan.disabled = true;
    form.querySelector('[data-lp-return-to]').value = '/checkout';
  }, true);
  document.addEventListener('change', function (event) {
    var form = event.target.closest && event.target.closest('[data-lp-buybox]');
    if (form) applyCheckedRow(form);
  });
  document.addEventListener('click', function (event) {
    var toggle = event.target.closest && event.target.closest('[data-lp-nutrition-toggle]');
    if (!toggle) return;
    var panel = toggle.parentNode.querySelector('[data-lp-nutrition]');
    if (!panel) return;
    panel.hidden = !panel.hidden;
    toggle.setAttribute('aria-expanded', String(!panel.hidden));
    toggle.textContent = toggle.getAttribute(panel.hidden ? 'data-label-closed' : 'data-label-open');
    if (!panel.hidden) panel.scrollIntoView({ behavior: reducedMotion() ? 'instant' : 'smooth', block: 'nearest' });
  });
  // The bar stands in for the listicle's top gold CTA, so it shows only once
  // that CTA has scrolled above the viewport, and leaves while add-to-cart is
  // on screen. A page without that CTA has nothing to wait for.
  var observers = [];
  function initBar() {
    observers.forEach(function (observer) { observer.disconnect(); });
    observers = [];
    var bar = document.querySelector('[data-lp-buybar]');
    var submitButton = document.querySelector('[data-lp-submit]');
    var trigger = document.querySelector('[data-lp-buybar-trigger]');
    var state = { ctaPassed: !trigger, submitVisible: false };
    function render() {
      bar.hidden = false;
      bar.classList.toggle('lp-buybar--away', !(state.ctaPassed && !state.submitVisible));
    }
    if (bar && submitButton && window.IntersectionObserver) {
      observers.push(new IntersectionObserver(function (entries) {
        state.submitVisible = entries[entries.length - 1].isIntersecting;
        render();
      }));
      observers[observers.length - 1].observe(submitButton);
      if (trigger) {
        // The root extends far below the viewport, so "not intersecting" can only
        // mean the CTA is above it, and a jump from above to below still fires.
        observers.push(new IntersectionObserver(function (entries) {
          state.ctaPassed = !entries[entries.length - 1].isIntersecting;
          render();
        }, { rootMargin: '0px 0px 100000px 0px' }));
        observers[observers.length - 1].observe(trigger);
      }
      if (window.ResizeObserver) {
        observers.push(new ResizeObserver(function () {
          document.documentElement.style.setProperty('--lp-buybar-room', bar.offsetHeight + 'px');
        }));
        observers[observers.length - 1].observe(bar);
      }
    }
  }
  initBar();
  document.addEventListener('lp:mount', initBar);
  // The plan cards' eases wait for lp-plans-live. WebKit runs this before a
  // section's <link> to lp-sleep.css has applied, and an ease already on when
  // the sheet lands runs every card in from unstyled. Reading the sheet's
  // token resolves its styles, so the class lands on cards at rest.
  function switchOnEases(form) {
    if (token(form, '--lp-dur-morph')) {
      form.classList.add('lp-plans-live');
    } else if (document.readyState !== 'complete') {
      window.addEventListener('load', function () { switchOnEases(form); }, { once: true });
    }
  }
  function init() {
    var form = document.querySelector('[data-lp-buybox]');
    if (!form) return;
    applyCheckedRow(form);
    switchOnEases(form);
  }
  init();
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('lp:mount', init);
})();
